var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable */
/**
 * Cancel Shipment Modal Component
 * Displays warnings and confirms shipment cancellation
 */
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import Modal from '@fp-suite/core-ui/src/components/Modal';
import ButtonAnt from '@fp-suite/core-ui/src/components/ButtonAnt';
export var CancelShipmentModal = function (_a) {
    var visible = _a.visible, onClose = _a.onClose, onConfirm = _a.onConfirm, shipmentId = _a.shipmentId;
    var t = useTranslation().t;
    var _b = React.useState(false), loading = _b[0], setLoading = _b[1];
    var handleConfirm = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, onConfirm()];
                case 2:
                    _a.sent();
                    onClose();
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    console.error('Error cancelling shipment:', error_1);
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [onConfirm, onClose]);
    return (_jsx(Modal, __assign({ title: String(t('Cancel Shipment')), visible: visible, onCancel: onClose, width: '500px' }, { children: _jsxs("div", __assign({ className: 'space-y-4' }, { children: [shipmentId && (_jsx("div", __assign({ className: 'p-3 bg-gray-50 rounded' }, { children: _jsxs("p", __assign({ className: 'text-sm text-gray-600' }, { children: [t('Shipment'), ": ", _jsx("span", __assign({ className: 'font-semibold' }, { children: shipmentId }), void 0)] }), void 0) }), void 0)), _jsx("div", __assign({ className: 'flex justify-center py-2' }, { children: _jsx(ExclamationCircleOutlined, { className: 'text-yellow-500', style: { fontSize: '48px' } }, void 0) }), void 0), _jsx("div", __assign({ className: 'p-3 bg-red-50 border border-red-200 rounded' }, { children: _jsx("p", __assign({ className: 'text-sm text-red-800' }, { children: t('Items have been packed/issued, these will be un-packed and returned to inventory') }), void 0) }), void 0), _jsx("div", __assign({ className: 'p-3 bg-yellow-50 border border-yellow-200 rounded' }, { children: _jsx("p", __assign({ className: 'text-sm text-yellow-800' }, { children: t('Payments associated with this shipment through order or invoice will not be changed') }), void 0) }), void 0), _jsxs("div", __assign({ className: 'p-3 bg-gray-50 rounded' }, { children: [_jsx("p", __assign({ className: 'text-sm font-medium text-gray-900' }, { children: t('Are you sure you want to cancel this shipment?') }), void 0), _jsx("p", __assign({ className: 'text-xs text-gray-600 mt-1' }, { children: t('This action cannot be undone.') }), void 0)] }), void 0), _jsxs("div", __assign({ className: 'flex justify-end gap-2 pt-2' }, { children: [_jsx(ButtonAnt, { buttonText: String(t('No, Keep Shipment')), onClick: onClose, disabled: loading }, void 0), _jsx(ButtonAnt, { buttonText: String(t('Yes, Cancel Shipment')), type: 'primary', danger: true, onClick: handleConfirm, loading: loading }, void 0)] }), void 0)] }), void 0) }), void 0));
};
export default CancelShipmentModal;
